<template>
  <div id="item-rate-breakdown-window">
    <section id="rate-breakdown-box" class="box-shadow">
      <header>
        <i class="ion ion-close-round sm" @click="close"></i>
        <blockquote>
          {{ headerText }}
        </blockquote>
      </header>
      <main id="totals-table-container">
        <h4>Current selection</h4>
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
            <tr>
              <th>Detail</th>
              <th>Value</th>
              <th v-if="workBenchComparison">
                Workbench option {{ workBenchComparison }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Provider Name</td>
              <td>{{ item.serviceProviderName }}</td>
              <td v-if="workBenchComparison">{{ comparison.serviceProviderName }}</td>
            </tr>
            <tr>
              <td>Provider Code</td>
              <td>{{ item.serviceProvider }}</td>
              <td v-if="workBenchComparison">{{ comparison.serviceProvider }}</td>
            </tr>
            <tr v-if="item.serviceNote">
              <td>Service Note</td>
              <td>{{ item.serviceNote }}</td>
              <td v-if="workBenchComparison">{{ comparison.serviceNote }}</td>
            </tr>
            <tr>
              <td>Quote Currency Rate</td>
              <td>{{ response.responseCurrency }} {{ numberFormat(item.baseRate) }}</td>
              <td v-if="workBenchComparison">{{ comparison.responseCurrency }} {{ numberFormat(comparison.baseRate) }}</td>
            </tr>
            <tr>
              <td>Tariff Currency Rate</td>
              <td>{{ item.currency }} {{ numberFormat(item.rate) }}</td>
              <td v-if="workBenchComparison"> {{ comparison.currency }} {{ numberFormat(comparison.reportingCurrencyRate) }}</td>
            </tr>
            <tr>
              <td>Duration</td>
              <td>{{ item.duration }} {{ item.durationType }}</td>
              <td v-if="workBenchComparison">{{ comparison.duration }} {{ comparison.durationType }}</td>
            </tr>
            <tr>
              <td>Quality</td>
              <td>{{ item.providerQuality || '' }}</td>
              <td v-if="workBenchComparison">{{ comparison.providerQuality || '' }}</td>
            </tr>
            <tr v-if="item.distance">
              <td>Distance</td>
              <td>{{ item.distance || '' }} {{ item.distanceType || '' }}</td>
              <td v-if="workBenchComparison">{{ comparison.distance || '' }} {{ comparison.distanceType || '' }}</td>
            </tr>
            <tr v-for="(value, detail) in item.details[0]">
              <td v-if="detail === 'rateInCurrency'">Calculated Tariff Rate (without Static Cost)</td>
              <td v-else-if="detail === 'staticCosts'">Additions (Static Costs)</td>
              <td v-else-if="detail === 'ratePer'">Tariff Line Rate (Rate Per)</td>
              <td v-else-if="detail === 'calculatedPer'">Per</td>
              <td v-else>{{ deCamel(detail) }}</td>
              <td v-if="detail === 'staticCosts' && value">
                <div v-for="(line) in value.split('; ')">
                  <span :class="{ 'red-highlight': line.includes('(Advice Only') }">{{line}}</span>
                </div>
              </td>
              <td v-else-if="detail === 'rateInCurrency'">
                {{ item.currency }} {{ getVal(value, detail) }}
              </td>
              <td v-else-if="detail === 'ratePer'">
                {{ item.currency }} {{ getVal(value, detail) }}
              </td>
              <td v-else>{{ getVal(value, detail) }}</td>
              <td v-if="workBenchComparison">
                {{ comparison.details[0].hasOwnProperty(detail) ? getVal(comparison.details[0][detail], detail) : '' }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <work-bench
          v-if="workbenchRequested && workBenchOptions.length"
          :options="workBenchOptions"
          v-on:choice-made="emitNewOption"
          :currentSelection="item"
          v-on:comparison="optionNumber => workBenchComparison = optionNumber"
        >
        </work-bench>
      </main>
      <footer class="clearfix pad-b5">
        <div class="pull-right full-w-sm">
          <div v-if="isWorkbenchEnabled" class="btn btn-primary sq full-w-sm"  @click="sendWorkbenchRequest">
            Workbench <pulse-loader v-show="loading" :size="'3px'" :style="{ display: 'inline' }"></pulse-loader>
          </div>
          <div class="btn btn-info sq full-w-sm"  @click="close">
            Back <i class="fa fa-backward"></i>
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>
<script>
  import API from '../../../api/endpoints.js'
  import WorkBench from './WorkBench.vue'
  import PulseLoader from '../../helpers/PulseLoader.vue'
  import event from '../../../event.js'
  import VueScrollTo from 'vue-scrollto'
  export default {
    name: 'QuoteRateItemBreakDown',
    props: [ 'rate', 'itemIndex', 'request', 'response' ],
    data () {
      return {
        workbenchRequested: false,
        loading: false,
        workBenchComparison: false,
        workBenchOptions: []
      }
    },
    components: {
      WorkBench,
      PulseLoader
    },
    computed: {
      isWorkbenchEnabled () {
        return !this.isSystemOptionParameterEnabled('DISABLE_WORKBENCH')
      },
      shouldSendSpecialWorkbenchRequest () {
        const specialRequestServices = [ 'OA', 'DA' ]
        return specialRequestServices.includes(this.item.service)
      },
      providersCodeToName () {
        return this.$store.getters['quote/providersCodeToName']
      },
      comparison () {
        setTimeout(() => {
          VueScrollTo.scrollTo('#item-rate-breakdown-window', 250, {})
        }, 100)
        return !this.workBenchComparison ? {
          details: [{}]
        } : this.workBenchOptions.find(({optionNumber}) => optionNumber === this.workBenchComparison)
      },
      totalCost () {
        return this.rate.item.reduce((val, item) => {
          return val + item.reportingCurrencyRate
        }, 0)
      },
      headerText () {
        return `Option ${this.rate.optionNumber} details - Item ${this.itemNumber} (${this.item.service})`
      },
      itemNumber () {
        return this.itemIndex + 1
      },
      item () {
        return this.rate.item[this.itemIndex]
      },
      workbenchRequest () {
        return {
          ...this.request,
          Service: this.item.service,
          TransportType: this.item.details[0].transportType,
          OriginalRateIdentifier: this.originalRateIdentifier
        }
      },
      /*
      * If the service is OA, then we have to send a 'special'
      * request as sometimes the OA and IN locations can
      * get out of sync
      */
      rateWorkbenchRequest () {
        let preferences = this.request.Preferences
        return {
          ...this.request,
          MaxNumberOfOptions: 1,
          Preferences: [ ...preferences, { ServiceProvider: this.item.serviceProvider, Service: this.item.service } ]
        }
      },
      originalRateIdentifier () {
        return this.item.details[0].rateIdentifier
      }
    },
    methods: {
      isSystemOptionParameterEnabled (whichCode) {
        return this.$store.getters['systemOption/isSystemParameterEnabled'](whichCode)
      },
      emitNewOption (option) {
        if (!this.shouldSendSpecialWorkbenchRequest) {
          event.$emit('toast', { type: 'success', message: 'Option updated' })
          this.$emit('close', {})
          this.$emit('update-option', { optionNumber: this.rate.optionNumber, itemIndex: this.itemIndex, option: option })
        } else {
          this.updateEntireRoute(option)
        }
      },
      updateEntireRoute ({ service, serviceProvider }) {
        let preferences = this.request.Preferences
        let req = {
          ...this.request,
          MaxNumberOfOptions: 1,
          Preferences: [ ...preferences, { ServiceProvider: serviceProvider, Service: service } ]
        }
        this.$store.dispatch('quote/sendSpecialWorkbenchRequest', req)
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Option updated' })
            this.$emit('close', {})
            this.$emit('update-option', { optionNumber: this.rate.optionNumber, option: data.option[0], updateEntireRoute: true })
          })
          .catch(err => {
            console.log(err)
          })
      },
      sendWorkbenchRequest () {
        this.workbenchRequested = true
        this.loading = true
        this.$store.dispatch('quote/sendWorkbenchRequest', this.workbenchRequest)
          .then(({data}) => {
            this.workBenchOptions = data.option
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            console.log(err)
          })
      },
      close () {
        this.$emit('close', {})
      },
      deCamel (string) {
        return string !== 'expiresAsDate' ? string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()) : 'Expires On Date'
      },
      getVal (val, detail) {
        if (['expiresAsDate', 'expiresOnDate', 'expires'].indexOf(detail) > -1) {
          return new Date(val).toString()
        } else if (typeof val === 'number') {
          return this.numberFormat(val)
        }
        return val
      }
    }
  }
</script>
<style scoped>
  header {
    position: relative;
  }
  .ion-close-round {
    position: absolute;
    cursor: pointer;
  }
  .ion-close-round.sm {
    top: 0px;
    right: 0px;
  }
  .input-tr td {
    padding: 0 !important;
    height: 37px;
  }
  .input-tr .is-input {
    height: 100%;
    width: 100%;
    border: none;
    padding-left: 4px;
  }
  #item-rate-breakdown-window {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2222;
    background: rgba(51, 80, 86, 0.6);
  }
  #rate-breakdown-box {
    margin: 40px auto 0 auto;
    background: #fff;
    width: 70%;
    padding:10px;
    max-height: 90%;
    overflow: auto;
  }
  /* Large Devices, Wide Screens */
  @media only screen and (max-width : 1200px) {
    #rate-breakdown-box {
      width: 60%;
    }
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width : 992px) {
    #rate-breakdown-box {
      width: 75%;
    }
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width : 768px) {
    #rate-breakdown-box {
      width: 85%;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width : 320px) {
    #rate-breakdown-box {
      width: 95%;
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.6;
    }
  }
  @keyframes fadeOut {
    from {
      opacity:0.6;
    }
    to {
      opacity: 0;
    }
  }
  thead {
    background-color: #428bca;
    color: #fff;
  }

  @media(max-width: 479px) {
    .full-w-sm {
      width: 100%;
    }
    .half-w-sm {
      width: 49%;
    }
  }
  tr td:nth-child(2) {
    text-align: left;
  }
  .pad-b5 {
    padding-bottom: 5px;
  }
  .box-shadow {
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: all 0.5s;
    padding: 10px;
    margin-bottom: 10px;
  }
  .box-shadow:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  .red-highlight {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// QuoteRateItemBreakDown.vue?1e567620